<script>
	import authBase from '@_system/components/auth/index.vue'
	export default {
		extends: authBase,
		props: {
			id: {
				type: [Number, String],
				default: () => {
					return 0
				}
			},
			extra: {
				type: Object,
				default: () => {
					return {}
				}
			},
			title: {
				type: String,
				default: () => {
					return '授权'
				}
			},
			authtab: {
				type: Array,
				default: () => {
					return ['department','staff','postjob','joblevel','group']
				}
			},
			isauth: {
				type: Boolean,
				default: () => {
					return true
				}
			}
		},
		data() {
			return {
				name: 'auth',
				activeName: this.authtab[0],
				store: {},
				fApi: {},
				modalShow: false,
				loading: true,
				width: '0',
				height: '0',
				num: {
					department: 0,
					staff: 0,
					postjob: 0,
					joblevel: 0,
					group: 0
				}

			}

		},

		watch: {

		},
		computed: {

		},
		created() {
			//console.log(this.id, this.extra.type)
		},
		mounted() {
			
		},
		methods: {
			show(){
				if (this.isauth) {
					this.$api[this.name].get(this.id, {
						type: this.extra.type,
						app: this.extra.app
					}).then((res) => {
						this.sourcedata = res
						if(this.sourcedata){
							this.initdata()
						}
						this.loading = false
					})
				} else {
					this.loading = false
				}
			},
			save(formData) {
				this.$api[this.name].save(formData).then(() => {
					this.$message({
						message: '操作成功',
						type: 'success'
					})
					this.back('cancle')
				})
			},
			submit() {
				let formData = {
					id: this.id,
					type: this.extra.type,
					app: this.extra.app,
					auth: this.initsubmitdata()
				}
				if (this.isauth) {
					this.save(formData)
				} else {
					this.$emit('submit', {
						data: formData.auth
					})
				}
			},
			back(type) {
				this.$emit('back', {
					type: type
				})
			},

		},
		components: {

		}
	}
</script>
